import React from 'react';
import styles from '../../../styles/TaskDetails.module.css';

interface StatusBadgeProps {
  status: 'pending' | 'in_progress' | 'completed' | 'pending_approval' | 'approved' | 'rejected' | 'cancelled' | 'on_hold';
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'completed':
        return {
          text: 'Completed',
          className: styles.statusCompleted,
         
          bgColor: '#d1fae5' 
        };
      case 'approved':
        return {
          text: 'Approved',
          className: styles.statusApproved,
          bgColor: '#a7f3d0' // Medium green
        };
      case 'in_progress':
        return {
          text: 'In Progress',
          className: styles.statusInProgress,
          bgColor: '#dbeafe' // Light blue
        };
      case 'pending_approval':
        return {
          text: 'Pending Approval',
          className: styles.statusPendingApproval,
          bgColor: '#fef3c7' // Light amber
        };
      case 'pending':
        return {
          text: 'Pending',
          className: styles.statusPending,
          bgColor: '#f3f4f6' // Light gray
        };
      case 'rejected':
        return {
          text: 'Rejected',
          className: styles.statusRejected,
          bgColor: '#fee2e2' // Light red
        };
      case 'cancelled':
        return {
          text: 'Cancelled',
          className: styles.statusCancelled,
          bgColor: '#fed7aa' // Light orange
        };
      case 'on_hold':
        return {
          text: 'On Hold',
          className: styles.statusOnHold,
          bgColor: '#e9d5ff' // Light purple
        };
      default:
        return {
          text: 'Unknown',
          className: styles.statusPending,
          bgColor: '#f3f4f6' // Light gray
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <div 
      className={`${styles.statusBadge} ${config.className} ${className}`}
      style={{
        backgroundColor: config.bgColor,
     
      }}
    >
      <span className={styles.statusText}>{config.text}</span>
    </div>
  );
};

export default StatusBadge;

